export default "__VITE_ASSET__CqlqYkQs__"